/* eslint-disable camelcase */
import type { TextStyle } from 'react-native';

export const black = '#000';
export const white = '#fff';
export const gray_1 = '#f7f8fa';
export const gray_2 = '#f2f3f5';
export const gray_3 = '#ebedf0';
export const gray_4 = '#dcdee0';
export const gray_5 = '#c8c9cc';
export const gray_6 = '#969799';
export const gray_7 = '#646566';
export const gray_8 = '#323233';
export const red = '#ee0a24';
export const blue = '#1989fa';
export const orange = '#ff976a';
export const orange_dark = '#ed6a0c';
export const orange_light = '#fffbe8';
export const green = '#07c160';

// Component Colors
export const primary_color = blue;
export const success_color = green;
export const danger_color = red;
export const warning_color = orange;
export const text_color = gray_8;
export const text_color_2 = gray_6;
export const text_color_3 = gray_5;
export const link_color = '#576b95';
export const active_color = gray_2;
export const active_opacity = 0.6;
export const disabled_opacity = 0.5;
export const background = gray_1;
export const background_2 = white;
export const background_3 = white;

// Padding
export const padding_base = 4;
export const padding_xs = padding_base * 2;
export const padding_sm = padding_base * 3;
export const padding_md = padding_base * 4;
export const padding_lg = padding_base * 6;
export const padding_xl = padding_base * 8;

// Font
export const font_size_xs = 10;
export const font_size_sm = 12;
export const font_size_md = 14;
export const font_size_lg = 16;
export const font_weight_bold: TextStyle['fontWeight'] = 'bold';
export const line_height_xs = 14;
export const line_height_sm = 18;
export const line_height_md = 20;
export const line_height_lg = 22;
export const base_font_family = `-apple-system, BlinkMacSystemFont, 'Helvetica Neue',
Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'miui', 'Hiragino Sans GB',
'Microsoft Yahei', sans-serif`;
export const price_integer_font_family = `Avenir-Heavy, PingFang SC, Helvetica Neue, Arial,
sans-serif`;

// Animation
export const animation_duration_base = 300;
export const animation_duration_fast = 200;

// Border
export const border_color = gray_3;
export const border_width_base = 1;
export const border_radius_sm = 2;
export const border_radius_md = 4;
export const border_radius_lg = 8;
export const border_radius_max = 999;
